if (!customElements.get('artvet-home-tabs')) {
  customElements.define('artvet-home-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.onClick = event => {
        const tab = event.target.closest('[role="tab"]');
        if (tab && this.contains(tab)) this.select(tab.dataset.animal, true);
      };
      this.onKey = event => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;
        let index = this.tabs.indexOf(tab);
        if (event.key === 'ArrowRight') index = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') index = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = this.tabs.length - 1;
        else return;
        event.preventDefault();
        this.tabs[index].focus();
        this.select(this.tabs[index].dataset.animal, true);
      };
      this.onAnimal = event => { if (event.detail.source !== this) this.select(event.detail.animal); };
      this.onBlock = event => {
        const panel = event.target.closest('[role="tabpanel"]');
        if (panel && this.contains(panel)) this.select(panel.dataset.animal, true);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      this.addEventListener('shopify:block:select', this.onBlock);
      document.addEventListener('artvet:animal-change', this.onAnimal);
      const selected = document.querySelector('artvet-home-tabs [role="tab"][aria-selected="true"]');
      if (selected) this.select(selected.dataset.animal);
    }
    select(animal, broadcast = false) {
      if (!this.tabs.some(tab => tab.dataset.animal === animal)) return;
      this.tabs.forEach(tab => {
        const active = tab.dataset.animal === animal;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.animal !== animal; });
      if (broadcast) document.dispatchEvent(new CustomEvent('artvet:animal-change', {detail: {animal, source: this}}));
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      this.removeEventListener('shopify:block:select', this.onBlock);
      document.removeEventListener('artvet:animal-change', this.onAnimal);
      this.bound = false;
    }
  });
}
